﻿import {GlobalConfig, GlobalContext} from "../contexts/GlobalContext";

export function useGlobalContext(): GlobalConfig {
	return GlobalContext.getData();
}
